module.exports = "/legacy/df24719a9e25b0e5c7511d0260235907.svg";